import React, { useState, useEffect } from 'react'

import '../../sytles/button.scss'

const BingoSquareP = () => {
    const [clicked, setClicked ] = useState(window.localStorage.getItem('toggleBtnHandler15') === 'true')

    useEffect(() => {
      window.localStorage.setItem('toggleBtnHandler15', clicked)
    }, [clicked]);

    const toggleBtnHandler = () => {
      setClicked(!clicked)
    }  

     {
      const styles = ['button']
      let text = 'Zalcano drop!'
      let bodyEl = document.body
      bodyEl.style.background = '#1f1f1f'
      
      if (clicked) {
        styles.push('clicked')
        text = 'Zalcano drop!';
        bodyEl.style.background = '#EEE'
      } 
      return (
     <div className={`main ${clicked ? "toggleBtnHandler": ''}`}>
        <div className={BingoSquareP}>
            <button className={styles.join(' ')} onClick={toggleBtnHandler}>{text}</button>
        </div>
     </div>
      )
    }
  }

  export default BingoSquareP
  
